import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilsBaseApiService<T> {
  readonly httpClient: HttpClient;
  constructor(
    @Inject('CONTEXT') protected readonly CONTEXT: string,
    protected injector: Injector,
    @Inject('BASE_URL') protected readonly BASE_URL: string
  ) {
    this.httpClient = injector.get(HttpClient);
  }

  protected getAll<T>(params?: { [param: string]: any }): Observable<T[]> {
    return this.httpClient.get<T[]>(`${this.BASE_URL}${this.CONTEXT}`, {
      params,
    });
  }

  protected getById<T>(id: string | number) {
    return this.httpClient.get<T>(`${this.BASE_URL}${this.CONTEXT}/${id}`);
  }

  protected create<T, C>(resource: T): Observable<C> {
    return this.httpClient.post<C>(`${this.BASE_URL}${this.CONTEXT}`, resource);
  }

  protected update<T>(resource: any): Observable<T> {
    return this.httpClient.put<T>(`${this.BASE_URL}${this.CONTEXT}`, resource);
  }

  protected updateById<T>(id: string, resource: T): Observable<T> {
    return this.httpClient.put<T>(
      `${this.BASE_URL}${this.CONTEXT}/${id}`,
      resource
    );
  }

  protected delete<T>(id: string | number) {
    return this.httpClient.delete<T>(`${this.BASE_URL}${this.CONTEXT}/${id}`);
  }

  protected insert<T>(resource: any): Observable<T> {
    return this.httpClient.post<T>(
      `${this.BASE_URL}${this.CONTEXT}/insert`,
      resource
    );
  }

  getQueryString(queryParams: { [key: string]: any }) {
    const queryEntries = Object.entries(queryParams);
    const filteredQuery = queryEntries.filter(
      ([key, value]) => typeof value !== 'undefined' && value !== '' && value !== null
    );
    return filteredQuery
      .map(([key, value]) => {
        if (value === 'null' || typeof value === 'undefined') return '';
        return `${key}=${value}`;
      })
      .join('&');
  }
}
